import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import Main from "./Containers/Main";
function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
